var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._t("keyText",function(){return [_c('span',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.keyText)+": ")])]}),_vm._t("valueText",function(){return [_c('span',[_vm._v(" "+_vm._s(_vm.valueText)+" ")])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }